<script setup lang="ts">
import { Maintenance, WisionLogo } from '@wision/ui';

const metaThemeColor = document.querySelector('meta[name=theme-color]');
metaThemeColor?.setAttribute('content', 'black');
</script>

<template>
  <div id="wrapper" class="h-full overflow-hidden font-light font-sans bg-black">
    <div class="flex flex-col items-center justify-center h-full p-4 text-white">
      <div id="content-container"
           class="flex flex-col items-center w-screen md:max-h-3/4 h-full justify-center relative">
        <Maintenance />
      </div>

      <div class="mx-auto mt-auto pb-2">
        <WisionLogo :width="40" />
      </div>
    </div>
  </div>
</template>
